import React, { useState } from 'react';

const Chatbot = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (input.trim() === '') return;

    const newMessage = { text: input, sender: 'user' };
    setMessages((prevMessages) => [...prevMessages, newMessage]);

    let botResponse = { text: "I'm sorry, I don't understand that. Can you ask about QR codes?", sender: 'bot' };

    const lowerInput = input.toLowerCase();

    if (lowerInput.includes('hello') || lowerInput.includes('hi')) {
      botResponse = { text: "Hello there! How can I help you with QR codes today?", sender: 'bot' };
    } else if (lowerInput.includes('qr code') || lowerInput.includes('what is qr')) {
      botResponse = { text: "A QR code is a two-dimensional barcode that can store various types of information, like text, URLs, or Wi-Fi credentials.", sender: 'bot' };
    } else if (lowerInput.includes('generate') || lowerInput.includes('how to make')) {
      botResponse = { text: "You can generate a QR code by selecting a type (like Text or URL) and entering your data in the input fields above. The QR code will update live!", sender: 'bot' };
    } else if (lowerInput.includes('download')) {
      botResponse = { text: "You can download the generated QR code as a PNG or SVG image using the buttons below the QR code preview.", sender: 'bot' };
    } else if (lowerInput.includes('customize') || lowerInput.includes('color') || lowerInput.includes('size')) {
      botResponse = { text: "Yes, you can customize the size, foreground color, background color, and error correction level of your QR code using the options provided.", sender: 'bot' };
    }

    setTimeout(() => {
      setMessages((prevMessages) => [...prevMessages, botResponse]);
    }, 500);

    setInput('');
  };

  return (
    <div className="chatbot-container">
      <button className="chatbot-toggle-button" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? 'X' : 'Chat'}
      </button>
      {isOpen && (
        <div className="chatbot-window shadow-lg">
          <div className="chatbot-header bg-primary text-white p-2 rounded-top">
            TagioQR Assistant
          </div>
          <div className="chatbot-messages p-2">
            {messages.map((msg, index) => (
              <div key={index} className={`message ${msg.sender}`}>
                <span className="message-bubble rounded p-2 mb-1 d-inline-block">
                  {msg.text}
                </span>
              </div>
            ))}
          </div>
          <form onSubmit={handleSendMessage} className="chatbot-input-form p-2 border-top">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Type your message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
              />
              <button type="submit" className="btn btn-primary">
                Send
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Chatbot;